/**
 * Client (Amt/Aemter) API Endpoints
 * Centralizes all client/organization-related API calls. `id` = documentId.
 */
import type { AxiosResponse } from "axios";
import api from "../api";
import type { ApiListResponse, ApiResponse, EntityPayload, QueryParams } from "../../types/api";
import type { Amt } from "../../types/entities";

export const clientApi = {
  getAll: (params: QueryParams = {}): Promise<ApiListResponse<Amt>> =>
    api.get("/api/aemters", { params }),

  getById: (id: string, params: QueryParams = {}): Promise<ApiResponse<Amt>> =>
    api.get(`/api/aemters/${id}`, { params }),

  create: (data: EntityPayload): Promise<ApiResponse<Amt>> => api.post("/api/aemters", { data }),

  update: (id: string, data: EntityPayload): Promise<ApiResponse<Amt>> =>
    api.put(`/api/aemters/${id}`, { data }),

  delete: (id: string): Promise<AxiosResponse> => api.delete(`/api/aemters/${id}`),
};
